import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './sideBar.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

function SideBar({ onIndicateurSelect }) {
  const [menuData, setMenuData] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [selectedIndicator, setSelectedIndicator] = useState(null);
  const [openGroups, setOpenGroups] = useState({});
  const [openCategories, setOpenCategories] = useState({});

  // Détecter la taille de l'écran
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    handleResize(); // Initialiser avec la taille actuelle
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    axios.get('https://indicateurapi.stats.ci/structure')
      .then(response => {
        setMenuData(response.data);
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des données:', error);
      });
  }, []);

  // Fonction pour vérifier si la sidebar est ouverte
  const isSidebarOpen = () => {
    return !document.body.classList.contains('toggle-sidebar');
  };

  // Fermer la sidebar sur mobile après sélection d'un indicateur
  const handleIndicateurSelect = (id) => {
    setSelectedIndicator(id);
    onIndicateurSelect(id);
    if (windowWidth < 1200) {
      document.body.classList.add('toggle-sidebar');
    }
  };

  // Gestionnaire pour ouvrir/fermer un groupe
  const toggleGroup = (groupId, e) => {
    e.preventDefault();
    setOpenGroups(prev => {
      // Si le groupe est déjà ouvert, on le ferme
      if (prev[groupId]) {
        const newState = {...prev};
        delete newState[groupId];
        return newState;
      } 
      // Sinon on l'ouvre
      return {...prev, [groupId]: true};
    });
  };

  // Gestionnaire pour ouvrir/fermer une catégorie
  const toggleCategory = (categoryId, groupId, e) => {
    e.preventDefault();
    setOpenCategories(prev => {
      // Si la catégorie est déjà ouverte, on la ferme
      if (prev[categoryId]) {
        const newState = {...prev};
        delete newState[categoryId];
        return newState;
      }
      // Sinon on l'ouvre
      return {...prev, [categoryId]: true};
    });
  };

  return (
    <aside id="sidebar" className="sidebar sidebar-visible" style={{paddingTop: 0, fontFamily: 'Montserrat, sans-serif'}}>
      <div style={{
        position: 'sticky', 
        top: 0, 
        left: 0, 
        right: 0, 
        background: 'linear-gradient(135deg, var(--primary-green) 75%, var(--primary-orange) 100%)', 
        padding: 0, 
        zIndex: 1060, 
        margin: 0, 
        width: '100%'
      }}>
        <h6 style={{
          color: 'white', 
          fontWeight: 'bold', 
          fontSize: '1rem', 
          textAlign: 'center', 
          margin: 0, 
          padding: '12px 0', 
          fontFamily: 'Montserrat, sans-serif',
          position: 'relative'
        }}>
          <i className="fas fa-chart-line" style={{marginRight: '8px'}}></i>
          Indicateurs
          <span style={{
            position: 'absolute',
            right: '15px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: 'var(--accent-orange)',
            boxShadow: '0 0 8px var(--accent-orange)'
          }}></span>
        </h6>
      </div>
      <ul className="sidebar-nav" id="sidebar-nav" style={{marginTop: 0, paddingTop: 0}}>
        {menuData.map(groupe => (
          <li key={groupe.id} className="nav-item">
            <a
              href="#"
              className={`nav-link ${openGroups[groupe.id] ? '' : 'collapsed'}`}
              onClick={(e) => toggleGroup(groupe.id, e)}
            >
              <i className="fas fa-folder"></i>
              <span>{groupe.nom}</span>
              <i className="fas fa-chevron-down"></i>
            </a>
            <ul 
              id={`groupe-${groupe.id}`} 
              className={`nav-content ${openGroups[groupe.id] ? 'show' : 'collapse'}`}
            >
              {groupe.categories.map(categorie => (
                <li key={categorie.id}>
                  <a
                    href="#"
                    className={`nav-link ${openCategories[categorie.id] ? '' : 'collapsed'}`}
                    onClick={(e) => toggleCategory(categorie.id, groupe.id, e)}
                  >
                    <i className="fas fa-folder-open"></i>
                    <span>{categorie.nom}</span>
                    <i className="fas fa-chevron-down"></i>
                  </a>
                  <ul 
                    id={`categorie-${categorie.id}`} 
                    className={`nav-content ${openCategories[categorie.id] ? 'show' : 'collapse'}`}
                  >
                    {categorie.indicateurs.map(indicateur => (
                      <li key={indicateur.id}>
                        <a 
                          href="#" 
                          onClick={(e) => {
                            e.preventDefault();
                            handleIndicateurSelect(indicateur.id);
                          }} 
                          className={`nav-link ${selectedIndicator === indicateur.id ? 'active' : ''}`}
                        >
                          <i className={`fas ${selectedIndicator === indicateur.id ? 'fa-chart-bar orange-icon' : 'fa-chart-line'}`}></i>
                          <span>{indicateur.nom}</span>
                          {selectedIndicator === indicateur.id && (
                            <span className="indicator-dot"></span>
                          )}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default SideBar;


